"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountRoutes = void 0;
const auth_route_1 = require("./auth_route");
class AccountRoutes extends auth_route_1.AuthRoute {
    constructor() {
        super('account');
    }
    /**
     * Returns true if the current user is an admin, false otherwise.
     */
    isAdmin() {
        return this.get(`/admin`, {});
    }
    /**
     * Add a phone number to the user's accounts.
     * In order to add a phone number, the user must recieve an OTP for than number and pass it to the endpoint.
     * @param { string } otp
     */
    addPhone(otp, otpType, identifier) {
        return this.post(`/phone?otp=${otp}`, {
            otpType,
            identifier
        });
    }
    /**
     * This endpoint will remove the “sms_auth” entry for that phone number from the user’s account.
     * @param { number | string } smsAuthId
     */
    deletePhone(smsAuthId) {
        return this.delete('/phone', { smsAuthId });
    }
    /**
     * Add an email to the user's account.
     * In order to add an email, the user must recieve an OTP for that email and pass it to the endpoint.
     * @param { string } otp
     */
    addEmail(otp, otpType, identifier) {
        return this.post(`/email?otp=${otp}`, {
            otpType,
            identifier
        });
    }
    /*
     * Returns a set of emails for the user ordered by created date
     */
    getEmails() {
        return this.get('/email', {});
    }
    /**
     * This will remove an email auth account from a user’s authentication options using the emailAuthId.
     * @param { number | string } emailAuthId
     */
    deleteEmail(emailAuthId) {
        return this.delete(`/email`, { emailAuthId });
    }
    /**
     * Returns the users authenticationMethods these currently include emails and phoneNumbers.
     * An authenticationMethod object contains an array of emails as well as an array of the user phoneNumbers.
     * The return format has the following shape:
     * {
        phoneNumbers: [{
          id: number;
          accountId: string;
          phoneNumber: string;
          country: string;
          updatedAt: Date;
          createdAt : Date;
        }],
        emails: [{
          id: number;
          accountId: string;
          email: string;
          updatedAt: Date;
          createdAt: Date;
        }]
      }
     */
    getAll() {
        return this.get('/all', {});
    }
    /** Check if a user for the provided auth method exists */
    exists(params) {
        if (params.email) {
            params.email = encodeURIComponent(params.email);
        }
        if (params.phone) {
            params.phone = encodeURIComponent(params.phone);
        }
        return this.get('/exists', params);
    }
}
exports.AccountRoutes = AccountRoutes;
//# sourceMappingURL=account.js.map